<template>
  <!-- 在线简历部分 -->
  <div class="resume-wrap">
    <Row type="flex" align="middle">
      <Col span="3">
        <img class="avatar" :src="resume.avatar" alt />
        <div class="online">在线状态</div>
      </Col>

      <Col span="20">
        <div class="resume-info">
          <div class="name-wrap">
            <span class="name">{{resume.name}}</span>
            <span>{{resume.brief}}</span>
          </div>
          <div class="experice desc-color">{{resume.expectations && resume.expectations.status}}</div>
        </div>
      </Col>
    </Row>
    <Row class="about-item" type="flex">
      <Col span="3">
        <span class="title">期望岗位</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.expectations && resume.expectations.position_name}}</Col>
    </Row>
    <Row class="about-item" type="flex">
      <Col span="3">
        <span class="title">期望行业</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.expectations && resume.expectations.industry}}</Col>
    </Row>
    <Row class="about-item" type="flex" v-if="resume.online_resume && resume.online_resume.regional">
      <Col span="3">
        <span class="title">区域</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.online_resume && resume.online_resume.regional}}</Col>
    </Row>
      <Row class="about-item" type="flex" v-else-if="resume.regional">
      <Col span="3">
        <span class="title">区域</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.regional}}</Col>
    </Row>
    <Row class="about-item" type="flex">
      <Col span="3">
        <span class="title">税前薪酬</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.expectations && resume.expectations.limit_msg}}</Col>
    </Row>
    <Row class="about-item" type="flex">
      <Col span="3">
        <span class="title">工作年限</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.start_work_year_msg}}</Col>
    </Row>
    <Row class="about-item" type="flex" v-if="resume.online_resume && resume.online_resume.position">
      <Col span="3">
        <span class="title">曾任岗位</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.online_resume && resume.online_resume.position || '暂无'}}</Col>
    </Row>
     <Row class="about-item" type="flex" v-else-if="resume.position">
      <Col span="3">
        <span class="title">曾任岗位</span>
      </Col>
      <Col span="20" class="desc-color">{{resume.position || '暂无'}}</Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "resume",
  props: {
    resume: {
      type: Object
    }
  }
};
</script>

<style lang="less" scoped>
// 在线简历
.resume-wrap {
  height: 640px;
  padding: 20px 40px;
  font-size: 14px;
  overflow: hidden;
  overflow-y: scroll;
  border-top: 1px solid rgba(54, 62, 79, 0.1);
  .avatar {
    width: 62px;
    height: 62px;
    border-radius: 50%;
  }
  .experice {
    margin: 5px 0 20px 0;
  }
  .online {
    opacity: 0.3;
    margin-bottom: 20px;
  }
  .name-wrap {
    .name {
      font-size: 20px;
    }
    span {
      margin-right: 20px;
    }
  }
  .about-item {
    font-size: 14px;
    color: #363e4f !important;
    margin-bottom: 20px;
    .title {
      line-height: 22px;
    }
    .desc,
    .desc-color {
      opacity: 0.7;
    }
    .desc {
      margin: 10px 0 20px 0;
      text-align: justify;
      text-align-last: left;
    }
    .tag {
      display: inline-block;
      padding: 4px 10px;
      background: rgba(54, 62, 79, 0.1);
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .line {
      margin: 0 10px;
    }
  }
}
</style>
